define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/table/matrix/ColumnVector"
], function(declare,domClass,ColumnVector) {

	return declare(ColumnVector, {
		columnPath: "Child:Section/Child:Subtype/Child:Settings/Child:DeviationRanges",
		
		_getColumnSpecHeaderParams: function(/*Context*/ctx, /*Heading*/h, /*Number*/index) {
			var columnHeader = this.inherited(arguments);
			
			if (columnHeader.innerText == "-999.00") {
				columnHeader.innerText = "<<"
			} else if (columnHeader.innerText == "999.00") {
				columnHeader.innerText = ">>"
			}
			
			return columnHeader;	
		},
		
		render: function(/*Context*/ctx, /*QueryResult*/qr, /*Spec*/c, /*Number*/nColumn, /*DOMNode*/td) {

			var nColumn = this.inherited(arguments);

			// the first and the last 4 columns are out of tolerance
			// color them light blue
			if (c.columnIndex <= 3 || c.columnIndex >=9) {
				domClass.add(td, "OutOfTolerance");
				
				// make nonzero out of tolerance values bold
				if (td.innerText != "0") {
					domClass.add(td, "OutOfToleranceBold");
				}
			}

			return nColumn;

		}
	
	});
});